<template>
  <div>
    <FrameHeader/>
    
    <!-- <div v-if="!item" class="text-dark tac p-5">Loading...</div> -->

    <div class="pc-full-page page-detail">
      <div class="pc-left">
        <div class="pic-holder">
          <!-- <img :src="item.image"> -->
          <CpNftCoverImg
            :src="item.image"
          />
        </div>
      </div>
      <div class="pc-right rel">

        <div id="sp-scroll-box" :class="['scroll-box pb-4',{'left-bottom-space': status_show_btn_cancel || status_show_btn_buy || status_show_btn_sell}]">

          <!-- name -->
          <div class="pt-5">
            <h2 class="mb-1 tac">
              {{item.name | transItemName}}
            </h2>
            <div class="tac">
              <router-link 
                class="c h-c"
                :to="{
                  name: 'assetsuit',
                  params: {
                    address: meta_item.nft_address,
                  },
                }">
                {{meta_item.nft_name}}
              </router-link>
            </div>

            <div v-if="meta_item.amount" class="t-gray tac small mr-1 mt-2">
              <i class="fas fa-user"></i>
              {{lg('',{
                en: 'Owner own',
                zh: '持有者拥有',
              })}}
              {{meta_item.amount}}
            </div>
            <div class="my-4 d-flex justify-content-center">
              
              <button 
                class="btn btn-outline-primary gray px-4 mr-3"
                style="border-radius: 12px"
                @click="setLikeStatus()" 
                >
                <i :class="['fa fa-heart mr-2',{'c':status_liked}]"></i>
                {{lg('',{
                  en: 'Like',
                  zh: '喜欢',
                })}}
                <span v-if="meta_item.like_info">
                  {{meta_item.like_info.likeNum}}
                </span>
              </button>

              <button 
                class="btn btn-outline-primary gray px-4 ml-3 d-flex align-items-center"
                style="border-radius: 12px"
                @click="showPopupShareItem()"
                >
                <i class="ui-icon-share mr-2"></i>
                {{lg('',{
                  en: 'Share',
                  zh: '分享',
                })}}
              </button>

            </div>
          </div>

          <!-- tabs -->
          <div>
            <div class="ui-tabset-style2 rowed-style">
              <span 
                :class="['tab',{on: on_tab === 'info'}]"
                @click="on_tab = 'info'"
                >
                {{lg('',{
                  en: 'Information',
                  zh: '信息',
                })}}
              </span>
              <span 
                :class="['tab',{on: on_tab === 'trade'}]"
                @click="on_tab = 'trade';"
                >
                {{lg('',{
                  en: 'History',
                  zh: '交易记录',
                })}}
              </span>
              <!-- mark - for bid: 02 竞价tab-->
              <span 
                :class="['tab',{on: on_tab === 'bid'}]"
                @click="on_tab = 'bid';"
                >
                {{lg('',{
                  en: 'Bids',
                  zh: '竞价记录',
                })}}
              </span>
            </div>
            <div class="p-4">
              
              <!-- info list -->
              <div v-if="on_tab === 'info'" class="list-owner">

                <!-- des -->
                <div v-if="item.description" class="mb-4">
                  <h6 class="b mt-3">
                    {{lg('',{
                      en: 'Description',
                      zh: '介绍',
                    })}}:
                  </h6>
                  {{item.description}}
                </div>

                <!-- attributes: suplly... -->
                <div 
                  v-if="
                    item.attributes.find(attr => attr.trait_type === 'Max Supply') ||
                    item.attributes.find(attr => attr.trait_type === 'Type') 
                  "
                  class="mb-4"
                  >
                  <h6 class="b mt-3">
                    {{lg('',{
                      en: 'Properties',
                      zh: '属性',
                    })}}:
                  </h6>
                  <div class="small">

                    <div 
                      v-for="(item,index) of (item.attributes || [])" 
                      :key="index"
                      class="border px-2 py-1 bg-light mb-2" style="border-radius: 10px;"
                      >
                      <span>
                        {{item.trait_type}}
                      </span>
                      <span class="float-right">
                        {{item.value}}
                      </span>
                    </div>

                    <!-- <div 
                      v-if="item.attributes.find(attr => attr.trait_type === 'Max Supply')" 
                      class="border px-2 py-1 bg-light mb-2" style="border-radius: 10px;"
                      >
                      <span>
                        {{item.attributes.find(attr => attr.trait_type === 'Max Supply').trait_type}}
                      </span>
                      <span class="float-right">
                        {{item.attributes.find(attr => attr.trait_type === 'Max Supply').value}}
                      </span>
                    </div> -->
                    
                    <div 
                       v-if="item.attributes.find(attr => attr.trait_type === 'Type')" 
                      class="border px-2 py-1 bg-light mb-2" style="border-radius: 10px;"
                      >
                      <span>
                        {{item.attributes.find(attr => attr.trait_type === 'Type').trait_type}}
                      </span>
                      <span class="float-right">
                        {{item.attributes.find(attr => attr.trait_type === 'Type').value}}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- chain info -->
                <div class="mb-4">
                  <h6 class="b mt-3">
                    {{lg('',{
                      en: 'Chain info',
                      zh: '链信息',
                    })}}:
                  </h6>
                  <div class="small">

                    <div class="d-flex border-bottom py-2">
                      <span>
                        {{lg('',{
                          en: 'Contract Address',
                          zh: '合约地址',
                        })}}
                      </span>
                      <a 
                        :href="$store.state.sitecfg.url_network_address_view + meta_item.nft_address" 
                        target="_blank"
                        class="ml-auto"
                        >
                        {{meta_item.nft_address | shortAddress}}
                      </a>
                    </div>
                    <div class="d-flex border-bottom py-2">
                      <span>
                        {{lg('',{
                          en: 'Token ID',
                          zh: '',
                        })}}
                      </span>
                      <span class="ml-auto">
                        {{meta_item.nft_id}}
                      </span>
                    </div>
                    <div class="d-flex border-bottom py-2">
                      <span>
                        {{lg('',{
                          en: 'Blockchain',
                          zh: '',
                        })}}
                      </span>
                      <span class="ml-auto">
                        BSC
                      </span>
                    </div>
                  </div>
                </div>

                <!-- 旧的 owner 等信息 -->
                <div v-if="0">
                  <div class="border-bottom py-3">
                    <div class="media">
                      <span class="ui-avatar mr-2 size-25">
                        <img :src="meta_item.owner_info.imageURL || '/static/pic/default_pic/default_avatar.jpg'">
                      </span>
                      <div class="media-body">
                        <div class="t-gray">
                          {{lg('owner')}}
                        </div>
                        <div>
                          <router-link 
                            :to="{
                              name: 'gallery',
                              query: {
                                addrfrom: meta_item.owner_info.address
                              },
                            }"
                            v-if="meta_item.owner_info && meta_item.owner_info.username" 
                            class="mr-2">
                            {{meta_item.owner_info.username}}
                          </router-link>
                          <a :href="$store.state.sitecfg.url_network_address_view + item.to" target="_blank" class="c h-c">
                            {{meta_item.owner | shortAddress}}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="border-bottom py-3">
                    <div class="media">
                      <span class="ui-avatar mr-2 size-25">
                        <img :src="creator_info.imageURL || '/static/pic/default_pic/default_avatar.jpg'">
                      </span>
                      <div class="media-body">
                        <div class="t-gray">
                          {{lg('',{
                            en: 'Creator',
                            zh: '艺术家',
                          })}}
                        </div>
                        <div>
                          <router-link 
                            :to="{
                              name: 'gallery',
                              query: {
                                addrfrom: creator_info.Creator || creator_info.address
                              },
                            }"
                            v-if="creator_info.username" 
                            class="mr-2"
                            >
                            {{creator_info.username}}
                          </router-link>
                          <a :href="$store.state.sitecfg.url_network_address_view + creator_info.Creator" target="_blank" class="c h-c">
                            {{creator_info.Creator | shortAddress}}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="border-bottom py-3">
                    <div class="media">
                      <span class="ui-avatar mr-2 size-25">
                        <img :src="collection_data.image || '/static/pic/default_pic/default_avatar.jpg'">
                      </span>
                      <div class="media-body">
                        <div class="t-gray">
                          {{lg('',{
                            en: 'Collection',
                            zh: '收藏系列',
                          })}}
                        </div>
                        <div>
                          {{meta_item.nft_name}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>

              <!-- history list -->
              <div v-if="on_tab === 'trade'">

                <CpBlockHistory v-if="on_tab === 'trade'" :list_history="list_history" />

                <div class="mt-4" style="height: 20px;">
                  <div v-if="on_tab === 'trade' && status_loading_history" class="t-gray tac">
                    Loading... 
                  </div>
                  <CpLoadOnScroll
                    :fn_load_data="getHistory"
                    :status_no_more_data="history__status_no_more_data"
                    :selector_el_scroll_box="selector_el_scroll_box"
                  />
                </div>
              </div>

              <!-- bid list -->
              <div v-if="on_tab === 'bid'">
                <div v-if="status_loading_bid" class="t-gray tac">
                  Loading... 
                </div>
                <div v-else>
                  <div 
                    v-for="(item,index) of list_bid" 
                    :key="index"
                    class="border-bottom py-3"
                    >

                    <div class="media align-items-center">
                      <div class="mr-3">
                        <span class="ui-avatar size-50 mt-1">
                          <img :src="item.address_info.imageURL || '/static/pic/default_pic/default_avatar.jpg'" alt="">
                        </span>
                      </div>
                      <div class="media-body b d-flex align-items-center">

                        <div>
                          <div>
                            {{item.buyValue}}
                            {{lg('', ($store.state.web3.account_wallet.find(coin => coin.id == item.currency) || {}).names )}}
                          </div>
                          <div>
                            <span class="t-gray">
                              by 
                            </span>
                            <a :href="$store.state.sitecfg.url_network_address_view + item.address" target="_blank" class="c h-c">
                              {{item.address | shortAddress}}
                            </a>
                          </div>
                        </div>
                        <div class="ml-auto">
                          <button 
                            :disabled="status_biding"
                            v-if="item.owner.toLowerCase() === $store.state.web3.account.toLowerCase()"
                            @click="acceptBid(item)"
                            class="btn btn-primary btn-sm"
                            >
                            {{lg('',{
                              en: 'Accept',
                              zh: '接受',
                            })}}
                          </button>
                        </div>

                      </div>
                    </div>
                    <!-- <div class="d-flex">
                      <span class="t-gray">
                        {{item.timestamp | time2passedtime}}
                      </span>
                      <span class="ml-auto b small pr-2">
                        {{item.buyValue}}
                        {{lg('', ($store.state.web3.account_wallet.find(coin => coin.id == item.currency) || {}).names )}}
                      </span>
                    </div>
                    <div class="d-flex">
                      <span class="pt-2">
                        by 
                        <a :href="$store.state.sitecfg.url_network_address_view + item.address" target="_blank" class="c h-c">
                          {{item.address | shortAddress}}
                        </a>
                      </span>
                      <span class="ml-auto">
                        <button 
                          :disabled="status_biding"
                          v-if="item.owner.toLowerCase() === $store.state.web3.account.toLowerCase()"
                          @click="acceptBid(item)"
                          class="btn btn-primary btn-sm"
                          >
                          {{lg('',{
                            en: 'Accept',
                            zh: '接受',
                          })}}
                        </button>
                      </span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 主要操作按钮 -->
          <div v-if="1 || status_show_btn_cancel || status_show_btn_buy || status_show_btn_sell" class="btn-box tac">
            <div class="box-holder"></div>

            
            <div class="box-main py-3 d-flex flex-column justify-content-center">
              
              <!-- 这里不会触发到 -->
              <!-- mark - for bid: 03 开放bid后这里不会再显示出来了 -->
              <div v-if="0 && !status_show_btn_sell && !status_show_btn_buy && !status_show_btn_cancel">

                <div v-if="!status_loading_meta_item">
                  <button  class="btn btn-primary cd uppercase" style="min-width: 160px;">
                    {{lg('',{
                      en: 'Currently not for sale',
                      zh: '暂时是非卖品',
                    })}}
                  </button>
                </div>
                
              </div>
              <div v-else>
                <div class="w-100">
                  
                  <span 
                    v-if="status_doing_cancel || status_unbiding" 
                    class="ui-loading-icon size-sm"
                  ></span>

                  <div v-else>

                    <button v-if="status_show_btn_cancel && !status_doing_cancel" @click="btnCancelSell()" :disabled="status_doing_cancel" class="btn btn-primary btn-round" style="min-width: 130px;">
                      <!-- {{lg('cancel')}} -->
                      {{lg('',{
                        en: 'Cancel Sell',
                        zh: '取消售卖',
                      })}}
                    </button>


                    <button v-if="status_show_btn_buy" @click="btnToggleBuy()" class="btn btn-primary btn-round" style="min-width: 130px;">
                      {{lg('',{
                        en: 'Buy Now',
                        zh: '购买',
                      })}}
                    </button>

                    <button v-if="status_show_btn_sell" @click="btnToggleSell()" class="btn btn-primary uppercase btn-round" style="min-width: 130px;">
                      {{lg('sell')}}
                    </button>

                    <!-- mark - for bid: 01 -->
                    <button v-if="status_show_btn_bid" @click="btnToggleBid()" class="btn btn-primary btn-round ml-2" style="min-width: 130px;">
                      {{lg('',{
                        en: 'Place a bid',
                        zh: '竞价',
                      })}}
                    </button>
                    <button v-if="status_show_btn_unbid" @click="cancelMyBid()" class="btn btn-primary btn-round ml-2" style="min-width: 130px;">
                      {{lg('',{
                        en: 'Cancel Bid',
                        zh: '取消竞价',
                      })}}
                    </button>
                  </div>


                </div>
                <div class="mt-2" v-if="status_show_btn_buy || status_show_btn_sell">
                  <span class="t-gray">
                    {{lg('service_fee')}}
                    <b>
                      2.5%. 
                    </b> 
                  </span>

                  <span v-if="meta_item.sell_info && meta_item.sell_info.buyValue">
                    <b class="c">
                      {{meta_item.sell_info.buyValue * fee_rate | tofixed6}}
                      {{lg('', $store.state.web3.account_wallet.find(coin => coin.id == meta_item.sell_info.currency).names )}}  
                    </b>
                    <span class="t-gray">
                      (${{meta_item.sell_info.buyValue* fee_rate | tokenToUsd(meta_item.sell_info.currency)}}
                      {{lg('',{
                        en: 'USD',
                        zh: '美元',
                      })}})
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <popBuy
          :cfg_status_poppad="cfg_status_poppad_buy"
          :item="item"
          :meta_item="meta_item"
        />

        <popBid
          :cfg_status_poppad="cfg_status_poppad_bid"
          :item="item"
          :meta_item="meta_item"
        />

        <popSell
          :cfg_status_poppad="cfg_status_poppad_sell"
          :item="item"
          :meta_item="meta_item"
        />

      </div>

    </div>

    <UiModal :open="status_ajaxing_approve">
      <div class="p-5 tac">
        <div class="ui-loading-icon"></div>
      </div>
    </UiModal>

    <!-- <FrameFooter/> -->

  </div>
</template>

<script>
import {mapActions} from 'vuex'

import popSell from './pop_sell.vue'
import popBuy from './pop_buy.vue'
import popBid from './pop_bid.vue'

import bus from '@/bus.js'

export default {
  name: 'detail',
  components: {
    popSell,
    popBuy,
    popBid,
  },
  props: [],
  data() {
    return {
      // info, trade
      on_tab: 'info',

      cfg_status_poppad_sell: false,
      cfg_status_poppad_buy: false,
      cfg_status_poppad_bid: false,

      status_show_btn_cancel: false,
      status_show_btn_buy: false,
      status_show_btn_sell: false,
      status_show_btn_bid: false,
      status_show_btn_unbid: false,

      status_doing_cancel: false,

      status_loading_meta_item: false,  
      item: {
        attributes: [],
      },
      meta_item: {
        owner_info: {},
        sell_info: {},
      },
      creator_info: {},

      collection_data: {},

      // 
      status_loading_history: false,
      list_history: [],
      history__status_no_more_data: false,
      history__next_page_num: 1,

      // bid list
      status_biding: false,
      status_unbiding: false,
      list_bid: [],
      status_loading_bid: false,
      // bid approve
      status_ajaxing_approve: false,
      status_approved: false,
    }
  },
  computed: {
    selector_el_scroll_box(){
      if(document.documentElement.clientWidth >= 788){
        return '#sp-scroll-box'
      }else{
        return ''
      }
    },

    fee_rate(){
      let rate = '-'
      if(this.status_show_btn_sell){
        rate = 0.98
      }
      if(this.status_show_btn_buy){
        rate = 1.02
      }
      return rate
    },

    status_liked(){
      return this.uniCheckLikeStatus(this.meta_item)
    },
  },
  watch: {
    'on_tab'(val){
      if(val == "trade"){
        this.getHistory()
      }
      if(val == "bid"){
        this.listItemBidHistory()
      }
    },
    '$store.state.web3.account'(val){
      if(val){
        this.run()
      }
    },

    '$route.params.address'(){
      this.run()
    },
    '$route.params.id'(){
      this.run()
    },
    '$route.query.owner'(){
      this.run()
    },
  },
  methods: {
    ...mapActions([
      'verifyNFTOwner',
      'cancelSell',
      'acceptBidNFT',
      'cancelBid',
      'hasApproveNFT',
      'approveNFTWithPending',
    ]),

    showPopupShareItem(){
      let v = this
      bus.appvue.showPopupShareItem(
        Object.assign({},v.meta_item,v.item)
      )
    },

    async setLikeStatus(){
      let v = this
      let res = await v.uniSetLikeStatus(v.meta_item, !v.status_liked)
      
      let mark = v.meta_item.like_info.likeNum += (res?1:-1)
      v.meta_item.like_info.likeNum = mark >= 0 ? mark : 0
    },

    async btnCancelSell(){
      let v = this

      var order = v.meta_item['sell_info']

      let obj = {
        address: v.$store.state.web3.account,
        address_owner: order.address,
        token_address: order.nft_address,
        token_id: order.nft_id,
        salt: order.salt,
        signature: order.signature,
        buyValue: order.buyValue,
        currency: order.currency,
        type: v.meta_item.type,
        callback: function(){
          setTimeout(function(){
            v.status_doing_cancel = false
            v.run()
          },1000)
        },
        callbackOnErr: function(){
          v.status_doing_cancel = false
        }
      }

      v.status_doing_cancel = true
      await v.cancelSell(obj)
    },

    async getData(){
      let v = this

      // let res = await v.api('query_item_meme',{id: v.$route.params.id})
      
      // let origin_url = '' + v.meta_item.url + v.meta_item.nft_id
      // let res = await fetch(origin_url)
      // res = await res.json()

      let res = await v.uniFetchItemInfo(v.meta_item)

      v.item = res

      v.getCreatorInfo()
    },

    async getCreatorInfo(){
      let v = this
      let res = await v.api('query_item_creator',{
        'nft_address': v.$route.params.address,
        'nft_id': v.$route.params.id,
      })

      if(res.code == 0){
        v.creator_info = res.data
      }

    },

    async getHistory(){
      let v = this

      await v.uniGetCurrentBlockNum()

      // if(v.list_history.length === 0){
      //   v.status_loading_history = true
      // }

      let res = await v.api('query_item_history',{
        nft_address: v.$route.params.address,
        nft_id: v.$route.params.id,
        page_num: v.history__next_page_num,
      },{
        vue: v,
        // key_data: 'list_history',
        key_ajaxing: 'status_loading_history',
      })

      if(res && res.data && res.data.length){
        v.list_history = v.list_history.concat(res.data)
        v.history__next_page_num += 1
      }else{
        v.history__status_no_more_data = true
      }

      // v.status_loading_history = false
    },

    async listItemBidHistory(){
      let v = this

      let form = {
        nft_address: v.meta_item.nft_address,
        nft_id: v.meta_item.nft_id,
        owner: v.meta_item.owner,
      }

      await v.api('list_item_bid_history',form,{
        vue: v,
        key_data: 'list_bid',
        key_ajaxing: 'status_loading_bid',
      })

    },

    // accept bid 前的检查
    async checkApproveNFT(){
      let v = this
      let address_my = v.$store.state.web3.account
      let address_nft = v.meta_item.nft_address

      let mark = await v.hasApproveNFT({
        address: address_my,
        NTFS_TOKEN_ADDRESS: address_nft,
        type: v.meta_item.type,
        // todo... contract params...
      })
      console.log('check Approve NFT res :' + mark)
      v.status_approved = mark
    },

    wait(ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(ms)
        }, ms)
      })
    },

    async actionApproveNft(){
      let v = this
      if(v.status_ajaxing_approve){
        return
      }
      let address_my = v.$store.state.web3.account
      let address_nft = v.meta_item.nft_address

      v.status_ajaxing_approve = true
      await v.approveNFTWithPending({
        address: address_my,
        NTFS_TOKEN_ADDRESS: address_nft,
        type: v.meta_item.type,
        callback: function(){
          v.status_approved = true
          v.status_ajaxing_approve = false
        },
        callbackOnErr: function(){
          v.status_ajaxing_approve = false
        },
      })
      
      // 等待1s
      await v.wait(1000)

      console.log('action approve res: '+ v.status_approved)
      return v.status_approved
    },

    async acceptBid(item){
      let v = this
      if(v.status_ajaxing_approve){
        return
      }

      // 如果没有 approve 则走 approve 函数，并return后续
      if(!v.status_approved){
        await v.actionApproveNft()
        return
      }

      let form = {
        address: item.address,
        token_address: item.nft_address,
        token_id: item.nft_id,
        type: item.type || '1155',
        address_owner: item.owner,
        salt: item.salt,
        signature: item.signature,
        buyValue: item.buyValue,
        currency: item.currency,
      }

      v.status_biding = true
      await v.acceptBidNFT(form)
      v.status_biding = false

      setTimeout(function(){
        v.listItemBidHistory()
      },1000)
    },
    async cancelMyBid(item){

      let v = this
      
      item = item || v.list_bid.find(i => i.address.toLowerCase() == v.$store.state.web3.account.toLowerCase() )

      let form = {
        address: item.address,
        token_address: item.nft_address,
        token_id: item.nft_id,
        type: item.type || '1155',
        address_owner: item.owner,
        salt: item.salt,
        signature: item.signature,
        buyValue: item.buyValue,
        currency: item.currency,
      }

      v.status_unbiding = true
      await v.cancelBid(form)
      v.status_unbiding = false

      // 刷新页面
      setTimeout(function(){
        v.run()
      },1500)
    },

    async getMetaData(){
      let v = this
      
      let res = await v.api('query_item_detail',{
        'address': v.$store.state.web3.account || '',
        'nft_address': v.$route.params.address,
        'nft_id': v.$route.params.id,
        'owner': v.$route.query.owner,
      },{
        vue: v,
        key_ajaxing: 'status_loading_meta_item',
      })

      if(res.code == 0){
        if(!res.data.owner_info){
          res.data.owner_info = {}
        }
        v.meta_item = res.data
      }

      // meme data
      v.getData()

      // get more info
      v.getCollectionData()

      let address_my = v.$store.state.web3.account ||  ''
      let meta_item_owner = v.meta_item.owner || v.$route.query.owner

      // no order_info
      if( (!v.meta_item.sell_info.address || !v.meta_item.sell_info.id) ){
        
        // let d_owner = v.meta_item.sell_info.address || ''
        let d_owner = v.$route.query.owner || v.meta_item.owner

        if( d_owner.toLowerCase() === address_my.toLowerCase() ){
          let is_owner = await v.checkIsOwner()
          console.log('is_owner',is_owner)
          if(is_owner){
            v.status_show_btn_cancel = false
            v.status_show_btn_sell = true
            v.status_show_btn_buy = false
          }
          else{
            v.status_show_btn_cancel = false
            v.status_show_btn_sell = false
            v.status_show_btn_buy = false
          }
        }
        else{
          v.status_show_btn_cancel = false
          v.status_show_btn_sell = false
          v.status_show_btn_buy = false
        }
      }
      // be order_info
      else{
        let address_my = (v.$store.state.web3.account || '').toLowerCase()
        let address_owner = (v.meta_item.sell_info.address ||  '').toLowerCase()

        if(address_my === address_owner){
          v.status_show_btn_cancel = true
          v.status_show_btn_buy = false
          v.status_show_btn_sell = false
        }else{
          v.status_show_btn_cancel = false
          v.status_show_btn_buy = true
          v.status_show_btn_sell = false
        }
      }

      // get Bid info
      await v.listItemBidHistory()

      // no bid_info
      if(meta_item_owner.toLowerCase() === address_my.toLowerCase()){
        v.status_show_btn_bid = false
        v.status_show_btn_unbid = false

        // accept bid 前的approve检查
        v.checkApproveNFT()
      }
      else if(v.list_bid.find( i => i.address.toLowerCase() === address_my.toLowerCase() ) ){
        v.status_show_btn_bid = false
        v.status_show_btn_unbid = true
      }
      else{
        v.status_show_btn_bid = true
        v.status_show_btn_unbid = false
      }

    },

    async getCollectionData(){
      let v = this

      let nft_url = v.meta_item.nft_url

      if(!nft_url){
        return
      }

      let res = await fetch(nft_url)
      res = await res.json()
      
      v.collection_data = res || {}
    },

    btnToggleBid(val){
      let v = this

      // checklogin
      // 20201230 - no check for buy
      // if(!v.$store.state.user.local_user.address){
      //   bus.headervue.mark_sign_ui_call += 1
      //   return
      // }

      if(!v.$store.state.web3.account){
        bus.btnaccountvue.modalOpen = true
        return
      }

      v.cfg_status_poppad_bid = val!==undefined ? val : !v.cfg_status_poppad_bid
    },

    btnToggleBuy(val){
      let v = this

      // checklogin
      // 20201230 - no check for buy
      // if(!v.$store.state.user.local_user.address){
      //   bus.headervue.mark_sign_ui_call += 1
      //   return
      // }

      if(!v.$store.state.web3.account){
        bus.btnaccountvue.modalOpen = true
        return
      }

      // check wallet balance
      let token_type = v.meta_item.sell_info.currency
      let price = v.meta_item.sell_info.buyValue * 1.02
      let balance = v.$store.state.web3.account_wallet.find(item => item.id === token_type) || {}
      balance = balance.num
      if(price > balance){
        bus.appvue.showPopupAddFund({
          token_type: token_type,
          nft_name: v.item.name,
        })
        return
      }

      v.cfg_status_poppad_buy = val!==undefined ? val : !v.cfg_status_poppad_buy
    },

    btnToggleSell(val){
      let v = this

      // checklogin
      // 20201230 - no check for sell
      // if(!v.$store.state.user.local_user.address){
      //   bus.headervue.mark_sign_ui_call += 1
      //   return
      // }

      v.cfg_status_poppad_sell = val!==undefined ? val : !v.cfg_status_poppad_sell
    },

    async acttionBuy(){
      let v = this
      let address_my = v.$store.state.web3.acount
      console.log(address_my)
      alert('fn acttionBuy...')
    },

    

    async checkIsOwner(){
      let v = this

      if(!v.$store.state.web3.account){
        return false
      }

      let mark = await v.verifyNFTOwner({
        address: v.$store.state.web3.account,
        NTFS_TOKEN_ADDRESS: v.$route.params.address,
        NFT_ID: v.$route.params.id,
        type: v.item.type,
      })
      console.log('checkIsOwner:',mark)
      return mark
    },

    run(){
      let v = this
      v.status_show_btn_cancel = false
      v.status_show_btn_buy = false
      v.status_show_btn_sell = false
      v.status_show_btn_bid = false
      v.status_show_btn_unbid = false

      v.list_bid = []

      v.getMetaData()
    },
  },
  created() {
    let v = this

    v.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .page-detail{
    .pc-right{
      // background-color: ;

      .scroll-box{
        max-height: 100%;
        // 
        overflow: auto;

        &.left-bottom-space{
          max-height: calc(100% - 110px);
        }
      }

      .btn-box{

        .box-holder{
          height: 110px;
        }
        .box-main{
          height: 110px;
          background: rgba(230,230,230,0.94);
          position: absolute;
          width: 100%;
          bottom: 0;
          left:0;
        }
      }
    }
  }

  @media(min-width: 788px){
    .page-detail{

      display: flex;
  
      .pc-left {
        flex: 1;

        .pic-holder{
          height: 100%;
        }
      }
  
      .pc-right {
        width: 440px;
      }
    }
  }

  @media(max-width: 788px){
    .page-detail{
      .pc-left{
        .pic-holder{
          min-height: 300px;
          height: 350px;
          max-height: 400px;
        }
      }

      .pc-right{
        .btn-box{
          .box-holder{
            height: 130px;
          }
          .box-main{
            position: fixed;
            bottom: 0;
            width: 100%;
            z-index: 1;
          }
        }
      }
    }
  }
</style>